const reportConstructorService = {
  getDashboards: function (dashboards) {
    const dashboardData = [];

    let rowDashboart = [];

    dashboards.forEach((element) => {
      rowDashboart.push(element);
      if (rowDashboart.length === 4) {
        dashboardData.push(rowDashboart);
        rowDashboart = [];
      }
    });

    if (rowDashboart.length > 0) {
      dashboardData.push(rowDashboart);
    }

    if (dashboardData.length > 1 && dashboardData[dashboardData.length - 1].length < dashboardData[dashboardData.length - 2].length) {
      const columns = dashboardData[dashboardData.length - 2].length - dashboardData[dashboardData.length - 1].length;

      for (let i = 0; i < columns; i++) {
        dashboardData[dashboardData.length - 1].push(null);
      }
    }

    return dashboardData;
  },
  getPatternDashboards: function (patternReport, customReport) {
    const dashboards = patternReport.dashboards.filter((x) => {
      const isIncluede = customReport.dashboards.some((dashboard) => {
        return dashboard.codes === x.codes;
      });

      return !isIncluede;
    });

    return dashboards;
  },

  getPatternFields: function (patternReport, customReport) {
    const fields = patternReport.fields.filter((x) => {
      const isIncluede = customReport.fields.some((field) => {
        return field.dashboard.codes === x.dashboard.codes;
      });

      return !isIncluede;
    });

    return fields;
  },
};

export default reportConstructorService;
